import { RouteState } from "./state";
import { Action } from "redux";
import { LOCATION_CHANGE, LocationChangeAction } from "react-router-redux";

export function routeReducer(state: RouteState = {}, action: Action): RouteState {
    if (action.type === LOCATION_CHANGE) {
        return {
            current: (action as LocationChangeAction).payload,
            previous: state.current
        };
    }

    return state;
}
